<template>
  <div class="onboarding" pad-b="run:backToHome">
    <background
      :color="activeStep !== 1 ? 'grayed' : ''"
      :game="gameBackground"
    />
    <Navigation :isSimple="true" />
    <transition name="fade" mode="out-in">
      <keep-alive>
        <component
          :is="dynamicComponent"
          :game="game"
          @nextStep="changeActiveStep(activeStep + 1)"
        ></component>
      </keep-alive>
    </transition>

    <StepsBullets
      :steps="4"
      :activeStep="activeStep"
      @changeStep="changeActiveStep"
    />

    <div v-if="activeStep !== 1" class="onboarding__skip">
      <button-back
        :label="$t('skip')"
        color="white"
        id="pad-onboarding-back"
        pad-start
        pad-down="go:#confirm"
        pad-a="click"
        @click="skipOnboarding"
      />
      <div class="onboarding__skip__confirm">
        <checkbox-simple
          :label="$t('dont_ask_me')"
          id="confirm"
          tabindex="1"
          @change="confirmCheck"
        ></checkbox-simple>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import Gamepad from "@/utils/gamepadInit";

import Navigation from "@/components/Navigation.vue";
import StepsBullets from "@/components/ui/StepsBullets.vue";
import CheckboxSimple from "@/components/ui/CheckboxSimple";

import Step1 from "@/components/Onboarding/Step1.vue";
import Step2 from "@/components/Onboarding/Step2.vue";
import Step3 from "@/components/Onboarding/Step3.vue";
import Step4 from "@/components/Onboarding/Step4.vue";

export default {
  name: "Onboarding",
  components: {
    Navigation,
    CheckboxSimple,
    StepsBullets,
    Step1,
    Step2,
    Step3,
    Step4,
  },
  computed: {
    ...mapState({
      activeStep: (state) => state.activeStep,
      game: (state) => state.game,
    }),

    dynamicComponent() {
      return `Step${this.activeStep}`;
    },
    gameBackground() {
      return this.$route.query.game
        ? `onboarding-${this.$route.query.game}`
        : "onboarding";
    },
  },
  data() {
    return {
      skipConfirmation: false,
    };
  },
  created() {
    document.backToHome = this.backToHome;
  },

  methods: {
    backToHome() {
      this.$router.push({ name: `${this.game}` });
    },
    confirmCheck(checked) {
      this.skipConfirmation = checked;
    },
    changeActiveStep(step) {
      this.$store.dispatch("setStep", step);
      document.pad.focus("#pad-onboarding-back");
    },

    skipOnboarding() {
      if (this.skipConfirmation) {
        this.$store.dispatch("completeOnboarding");
      }

      this.$router.push({ name: `${this.game}` });
    },
  },

  mounted() {
    Gamepad();
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.4s;
}
.fade-enter {
  opacity: 0;
  margin-left: 90px;
}
.fade-leave-active {
  transition: all 0.4s;
  opacity: 0;
  margin-left: -100px;
}

.onboarding {
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 120px;

  &__skip {
    text-transform: uppercase;
    font-family: "Gilam SemiBold", sans-serif;
    font-size: 15px;
    color: $white-60;
    position: absolute;
    bottom: 20px;
    // right: 30px;
    right: 10px;
    z-index: 101;

    a {
      color: $white-60;
    }

    &__confirm {
      font-family: "Gilam Book", sans-serif;
      text-transform: none;
      margin-top: 15px;
    }
  }

  ::v-deep .background {
    .background__img {
      background-size: auto;
      height: 100%;
      background-position: top;
    }
  }
}

@media screen and (min-width: $screen-md) {
  .onboarding {
    &__skip {
      right: 100px;
    }
  }
}

@media screen and (min-width: $screen-lg) {
  .onboarding {
    &__skip {
      right: 120px;
    }
  }
}
</style>
